// Selectors


import { RootState } from '../../store';

export const walletSelector = (state: RootState) => state.walletState
